import RequestHandler from "./RequestHandler";
import { API_VERSIONS } from "../utils/constants";

function ProductVersionAPI() {
    const baseProductVersionApi = "product-versions";

    async function createProductVersion(payload) {
        try {
            const result = await RequestHandler.post(
                `${API_VERSIONS.v1}/${baseProductVersionApi}`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function listProductVersions(
        productId,
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "createdAt";
            const sortDirection = defaultSortDirection || "DESC";
            let URL = `${API_VERSIONS.v1}/${baseProductVersionApi}/list/${productId}?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateProductVersion(payload) {
        try {
            const result = await RequestHandler.put(
                `${API_VERSIONS.v1}/${baseProductVersionApi}`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function reviewSubmission(reviewBody) {
        try {
            const result = await RequestHandler.post(
                `${API_VERSIONS.v1}/${baseProductVersionApi}/review-submission`,
                reviewBody
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function productVersionById(id) {
        try {
            const result = await RequestHandler.get(
                `${API_VERSIONS.v1}/${baseProductVersionApi}/${id}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function getReviewSubmissionData(productVersionId) {
        try {
            const result = await RequestHandler.get(
                `${API_VERSIONS.v1}/${baseProductVersionApi}/details/${productVersionId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function activateVersion(id) {
        try {
            const result = await RequestHandler.put(
                `${API_VERSIONS.v1}/${baseProductVersionApi}/activate/${id}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function getActiveVersion(productId) {
        try {
            const result = await RequestHandler.get(
                `${API_VERSIONS.v1}/${baseProductVersionApi}/activate/${productId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function checkVersionName(productId, versionName) {
        try {
            const result = await RequestHandler.get(
                `${API_VERSIONS.v1}/${baseProductVersionApi}/check-version-name/${productId}?version=${versionName}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function removeProductVersion(versionId) {
        try {
            const result = await RequestHandler.remove(
                `${API_VERSIONS.v1}/${baseProductVersionApi}/${versionId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        listProductVersions,
        createProductVersion,
        updateProductVersion,
        reviewSubmission,
        getReviewSubmissionData,
        activateVersion,
        productVersionById,
        getActiveVersion,
        checkVersionName,
        removeProductVersion,
    };
}

export default ProductVersionAPI();
